/**
 * the enum for marriage
 */
export const Marriage = {
  single: "לרווקים בלבד",
  married: "לנשואים בלבד",
  all: "גם וגם",
};
